exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gwnl-eval-select-util{margin-left:-24px;margin-bottom:-24px}.gwnl-eval-select-util .talent-eval-card{margin-left:24px;margin-bottom:24px}.gwnl-eval-select-util .talent-eval-card .tag{height:20px;padding:0 4px;font-size:12px;line-height:20px;color:#8c8c8c;text-align:center;border:1px solid #d0d0d0;border-radius:2px}\n", ""]);

